module.exports = __webpack_public_path__ + "img/icon-transfer.ab7b504c.svg";